import {WALLDASH_CHANGE_SCREEN,
  WALLDASH_INIT,
  WALLDASH_STATS_INIT,
  WALLDASH_STATS_CHANGE_PROGRESS,
  WALLDASH_STATS_LOAD_DATA} from '../mutations/available'

import api from '../../api'

export const wdInit = async ({commit, state, dispatch}) => {
  const screenChangeIntervalId = setInterval(function () {
    dispatch('wdChangeScreen')
  }, state.walldash.screenChangeInterval)

  dispatch('wdCaseRegistrationStatsInit')
  dispatch('wdGrossingByDoctorsStatsInit')
  dispatch('wdGrossingByLabManagersStatsInit')
  dispatch('wdGlassesMicrotomedStatsInit')
  dispatch('wdGlassesScannedStatsInit')
  dispatch('wdDoctorOwnersStatsInit')
  dispatch('wdCollaboratorsStatsInit')
  commit(WALLDASH_INIT, screenChangeIntervalId)
}

export const wdChangeScreen = async ({commit, state}) => {
  let currentScreen = state.walldash.currentScreen + 1
  currentScreen = currentScreen % 3

  commit(WALLDASH_CHANGE_SCREEN, currentScreen)
}

// Case registration stats
export const wdCaseRegistrationStatsInit = async ({commit, state, dispatch}) => {
  const loadCaseRegistrationStatsIntervalId = setInterval(function () {
    dispatch('wdCaseRegistrationLoadStats')
  }, state.walldash.caseRegistrationStats.updateInterval)

  dispatch('wdCaseRegistrationLoadStats')
  commit(WALLDASH_STATS_INIT, {context: 'caseRegistrationStats', updateIntervalId: loadCaseRegistrationStatsIntervalId})
}

export const wdCaseRegistrationLoadStats = async ({commit, state}) => {
  if (state.walldash.caseRegistrationStats.inProgress) {
    return
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'caseRegistrationStats', value: true})

  try {
    const caseRegistrationStats = await api.getWdCaseRegistrationStats()
    commit(WALLDASH_STATS_LOAD_DATA, {context: 'caseRegistrationStats', value: caseRegistrationStats})
  } catch (e) {
    console.log(e)
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'caseRegistrationStats', value: false})
}

// Grossing by doctors stats
export const wdGrossingByDoctorsStatsInit = async ({commit, state, dispatch}) => {
  const loadGrossingByDoctorsStatsIntervalId = setInterval(function () {
    dispatch('wdGrossingByDoctorsLoadStats')
  }, state.walldash.grossingByDoctorsStats.updateInterval)

  dispatch('wdGrossingByDoctorsLoadStats')
  commit(WALLDASH_STATS_INIT, {context: 'grossingByDoctorsStats', updateIntervalId: loadGrossingByDoctorsStatsIntervalId})
}

export const wdGrossingByDoctorsLoadStats = async ({commit, state}) => {
  if (state.walldash.grossingByDoctorsStats.inProgress) {
    return
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'grossingByDoctorsStats', value: true})

  try {
    const grossingByDoctorsStats = await api.getWdGrossingByDoctorsStats()
    commit(WALLDASH_STATS_LOAD_DATA, {context: 'grossingByDoctorsStats', value: grossingByDoctorsStats})
  } catch (e) {
    console.log(e)
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'grossingByDoctorsStats', value: false})
}

// Grossing by labManagers stats
export const wdGrossingByLabManagersStatsInit = async ({commit, state, dispatch}) => {
  const loadGrossingByLabManagersStatsIntervalId = setInterval(function () {
    dispatch('wdGrossingByLabManagersLoadStats')
  }, state.walldash.grossingByLabManagersStats.updateInterval)

  dispatch('wdGrossingByLabManagersLoadStats')
  commit(WALLDASH_STATS_INIT, {context: 'grossingByLabManagersStats', updateIntervalId: loadGrossingByLabManagersStatsIntervalId})
}

export const wdGrossingByLabManagersLoadStats = async ({commit, state}) => {
  if (state.walldash.grossingByLabManagersStats.inProgress) {
    return
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'grossingByLabManagersStats', value: true})

  try {
    const grossingByLabManagersStats = await api.getWdGrossingByLabManagersStats()
    commit(WALLDASH_STATS_LOAD_DATA, {context: 'grossingByLabManagersStats', value: grossingByLabManagersStats})
  } catch (e) {
    console.log(e)
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'grossingByLabManagersStats', value: false})
}

// Glasses microtomed stats
export const wdGlassesMicrotomedStatsInit = async ({commit, state, dispatch}) => {
  const loadGlassesMicrotomedStatsIntervalId = setInterval(function () {
    dispatch('wdGlassesMicrotomedLoadStats')
  }, state.walldash.glassesMicrotomedStats.updateInterval)

  dispatch('wdGlassesMicrotomedLoadStats')
  commit(WALLDASH_STATS_INIT, {context: 'glassesMicrotomedStats', updateIntervalId: loadGlassesMicrotomedStatsIntervalId})
}

export const wdGlassesMicrotomedLoadStats = async ({commit, state}) => {
  if (state.walldash.glassesMicrotomedStats.inProgress) {
    return
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'glassesMicrotomedStats', value: true})

  try {
    const glassesMicrotomedStats = await api.getWdGlassesMicrotomedStats()
    commit(WALLDASH_STATS_LOAD_DATA, {context: 'glassesMicrotomedStats', value: glassesMicrotomedStats})
  } catch (e) {
    console.log(e)
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'glassesMicrotomedStats', value: false})
}

// Glasses scanned stats
export const wdGlassesScannedStatsInit = async ({commit, state, dispatch}) => {
  const loadGlassesScannedStatsIntervalId = setInterval(function () {
    dispatch('wdGlassesScannedLoadStats')
  }, state.walldash.glassesScannedStats.updateInterval)

  dispatch('wdGlassesScannedLoadStats')
  commit(WALLDASH_STATS_INIT, {context: 'glassesScannedStats', updateIntervalId: loadGlassesScannedStatsIntervalId})
}

export const wdGlassesScannedLoadStats = async ({commit, state}) => {
  if (state.walldash.glassesScannedStats.inProgress) {
    return
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'glassesScannedStats', value: true})

  try {
    const glassesScannedStats = await api.getWdGlassesScannedStats()
    commit(WALLDASH_STATS_LOAD_DATA, {context: 'glassesScannedStats', value: glassesScannedStats})
  } catch (e) {
    console.log(e)
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'glassesScannedStats', value: false})
}

// Doctor owner stats
export const wdDoctorOwnersStatsInit = async ({commit, state, dispatch}) => {
  const loadDoctorOwnersStatsIntervalId = setInterval(function () {
    dispatch('wdDoctorOwnersLoadStats')
  }, state.walldash.doctorOwnersStats.updateInterval)

  dispatch('wdDoctorOwnersLoadStats')
  commit(WALLDASH_STATS_INIT, {context: 'doctorOwnersStats', updateIntervalId: loadDoctorOwnersStatsIntervalId})
}

export const wdDoctorOwnersLoadStats = async ({commit, state}) => {
  if (state.walldash.doctorOwnersStats.inProgress) {
    return
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'doctorOwnersStats', value: true})

  try {
    const doctorOwnersStats = await api.getWdDoctorOwnersStats()
    commit(WALLDASH_STATS_LOAD_DATA, {context: 'doctorOwnersStats', value: doctorOwnersStats})
  } catch (e) {
    console.log(e)
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'doctorOwnersStats', value: false})
}

// Collaborators stats
export const wdCollaboratorsStatsInit = async ({commit, state, dispatch}) => {
  const loadCollaboratorsStatsIntervalId = setInterval(function () {
    dispatch('wdCollaboratorsLoadStats')
  }, state.walldash.collaboratorsStats.updateInterval)

  dispatch('wdCollaboratorsLoadStats')
  commit(WALLDASH_STATS_INIT, {context: 'collaboratorsStats', updateIntervalId: loadCollaboratorsStatsIntervalId})
}

export const wdCollaboratorsLoadStats = async ({commit, state}) => {
  if (state.walldash.collaboratorsStats.inProgress) {
    return
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'collaboratorsStats', value: true})

  try {
    const collaboratorsStats = await api.getWdCollaboratorsStats()
    commit(WALLDASH_STATS_LOAD_DATA, {context: 'collaboratorsStats', value: collaboratorsStats})
  } catch (e) {
    console.log(e)
  }

  commit(WALLDASH_STATS_CHANGE_PROGRESS, {context: 'collaboratorsStats', value: false})
}



// WEBPACK FOOTER //
// ./src/store/actions/walldash.js